<script>
    // Imports
    import { COLOR_LOOKUP } from '../emotions-to-colors.js'
    import { createEventDispatcher } from 'svelte';
    import viewport from '../utils/useViewportAction.js';

    const dispatch = createEventDispatcher();

    // Props
    // export let audio = false;
    // export let imagePath = '';
    // export let section = '';
    // export let imageName = '';
    // export let audioPath = '';
    export let title = '';
    export let loss = '';
    export let body = '';
    export let emotions = '';
    export let firstName = '';
    export let lastName = '';
    export let neighborhood = '';
    export let age = '';
    export let webpPath = '';
    export let avifPath = '';
    export let imagePath = '';
    export let isExpanded = false;
    export let altText = '';
    export let credit = '';
    export let enteredViewport = false;

    // Component level settings
    let ref;

    let name = `${firstName}${ lastName ? " " + lastName : ""}`

    let emotionsString = emotions.split("\n").map(e => e.toLowerCase()).join(", ")

    // Process props
    const getGradientStyle = (emotions) => {
        let emotionsCleaned = emotions.split("\n").map(e => e.toLowerCase())
        let colors = emotionsCleaned.map(e => COLOR_LOOKUP[e] || '' ).filter(e => e.length)
        let colorString = colors.join(", ")
        if (colors.length == 1) {
            colorString = `${colors[0]}, ${colors[0]}`
        } else if (colors.length == 0 || !colors) {
            colorString = `#eee, #eee`
        }
        return `linear-gradient(to right top, ${colorString})`
    }

    const getBorderStyle = (emotions) => {
        return `background-image: ${ getGradientStyle(emotions) };`
    }


    const onClick = (e) => {
        // Scroll to clicked element
        setTimeout(() => {
            if (ref) {
                const targetPosition = ref.getBoundingClientRect().top + window.scrollY
                window.scrollTo({
                    top: targetPosition,
                });
            }
        }, 0);
    }

    const onClickX = (e) => {
        // Propogate to parent
        dispatch('closed', true)
        isExpanded = false;
        e.stopPropagation()
    }

    const setEnteredViewport = (val) => {
        enteredViewport = val
    }

</script>

<div class="card text-sans-serif" 
    use:viewport
    on:enterViewport={() => { setEnteredViewport(true) } }
    on:click={ onClick }
    on:keydown={ onClick }
    bind:this={ref}
>
    <div class="card-border" style="{ `${getBorderStyle(emotions)};` }" ></div>

    <div class="card-bg" style=""></div>

    <button type="button" aria-label="Close" class="card-x { `${ isExpanded ? "show" : "hide" }` }" on:click={ (e) => { onClickX(e) }}>
        <svg width="20" height="20" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.47391 1.64673L24.7644 24.9372" stroke="black" stroke-width="3"/>
            <path d="M24.8794 1.70953L1.5889 25" stroke="black" stroke-width="3"/>
        </svg>
    </button>

    <div class="card-inner" style="z-index: 2;" aria-live="polite">
        <!-- "Front" of card -->
        <div class="card--expanded__front { title.length > 50 ? "text-small" : "text-big" } { `${ isExpanded ? "hide" : "show" }` }">
            <p>
                { title }
            </p>
        </div>

        <!-- "Back" of card -->
        <div class="card--expanded__back { `${ isExpanded ? "show" : "hide" }` }">
            <div class="card--expanded__body">

                <!-- Image -->
                {#if imagePath && avifPath && webpPath }
                <div class="flex card--expanded__image-wrapper">
                    <div class="card--expanded__image">
                        <picture>
                            <source class="" type="image/avif" srcset="{ (enteredViewport || isExpanded) ? avifPath : '' }">
                            <source class="" type="image/webp" srcset="{ (enteredViewport || isExpanded) ? webpPath : '' }">
                            <img class="thumbnail"
                                src="{ (enteredViewport || isExpanded) ? imagePath : '' }"
                                srcset="{ (enteredViewport || isExpanded) ? imagePath: '' }"
                                alt="{ altText }">
                        </picture>
                    </div>
                    {#if credit}
                        <p class="card--expanded__credit">{ credit }</p>
                    {/if}
                </div>
                {/if}
                
                <!-- Text -->
                <div class="flex card--expanded__text">
                    <p class="card--expanded__header">What did you lose in the fires?</p>
                    <p style="margin-bottom: 30px;">{@html loss }</p>
                    <p class="card--expanded__header">Please share the meaning your loss holds for you.</p>
                    <p style="margin-bottom: 30px;">{ body }</p>
                    <p style="margin-bottom: 6px;">{ name }{ !isNaN(age) ? `, ${age}` : '' }</p>
                    <p style="margin-bottom: 6px;">{ neighborhood }</p> 
                    <p class="">Feeling: { emotionsString }</p> 
                </div>
            </div>
        </div>
    </div>
    
</div>